import { RegionHelper } from "../common/region_helper";

export type NavigateOptions = {
  /** Add current user region to the URL. Default is true. */
  withRegion: boolean;
};

const defaultNavigateOptions: NavigateOptions = {
  withRegion: true,
};

export function useRoute() {
  const navigate = (url: string, options: NavigateOptions = {}) => {
    const { withRegion } = { ...defaultNavigateOptions, ...(options ?? {}) };

    if (withRegion) {
      url = RegionHelper.addRegionToLink(url)
    }
    document.location = url;
  };

  return {
    navigate,
  };
}
